<template>
    <div></div>
</template>

<script type="text/javascript">

    const W13 = 12; // Отопление.
    const W99 = 3;  // Горячая вода.
    const W139 = 2; // ХВС.
    const W149 = 1; // Водоотведение.

    export default {
        name: 'account-recalc',

        props: {
            account: Object,
            updateTotal: null
        },
        data: function () {
            return {
                ssum: 0.0,
                payErr: -1,
                typeErr: 0,
                savePay: 0,
                payText: '',
                manSsum: 0.0,
                sumAllServices: 0.0,
                sumMainAddServices: 0.0,
                sumFineDuty: 0.0,
                sumWeightFactors: 0.0
            }
        },
        computed: {
            CopySaldoEnd: function (index) {
                return this.account.CalcData.Products[index].SaldoEnd;
            },
            idSsum: function () {
                return 'idSsum' + this.account.PersonAccountId;
            },
            sumRecalculation: function () {
                var sum = 0.0;
                for (var p in this.account.CalcData.Products) {
                    sum += this.account.CalcData.Products[p].Recalculation;
                }
                return Math.round(sum * 100) / 100;
            },
            sumDebtBeg: function () {
                var sum = 0.0;
                for (var p in this.account.CalcData.Products) {

                    if (this.account.CalcData.Products[p].IsFine && this.account.CalcData.Products[p].SaldoBegin > 0) {
                        sum += this.account.CalcData.Products[p].SaldoBegin;
                    }
                    if (!this.account.CalcData.Products[p].IsFine) {
                        sum += this.account.CalcData.Products[p].SaldoBegin;
                    }
                }
                return Math.round(sum * 100) / 100;
            },
            sumPaid: function () {
                var sum = 0.0;
                for (var p in this.account.CalcData.Products) {
                    sum += this.account.CalcData.Products[p].Paid;
                }
                return Math.round(sum * 100) / 100;
            },
            sumAccruals: function () {
                var sum = 0.0;
                if (this.account.CalcData.CanPay) {

                    for (var p in this.account.CalcData.Products) {
                        if (this.account.CalcData.Products[p].AccrualsCheck) {
                            sum += this.account.CalcData.Products[p].Accruals;
                        }
                    }
                }
                else {
                    for (var p in this.account.CalcData.Products) {
                        sum += this.account.CalcData.Products[p].Accruals;
                    }
                }
                return Math.round(sum * 100) / 100;
            }
        },
        methods: {
            recalcSsum: function (newSum) {
                this.manSsum = newSum;;
                if (this.manSsum == '') this.manSsum = '0.00';
                if (typeof (this.manSsum) == "string") {
                    this.manSsum = this.manSsum.replace(',', '.');
                    this.manSsum = Number(this.manSsum);
                }
                if (isNaN(this.manSsum)) return;
                var lastIndex = -1;
                var difference = this.manSsum - this.sumAllServices;
                if (difference !== 0.0) {
                    if (this.account.Status === 1) {
                        if (difference < 0) {
                            if (this.manSsum >= this.sumMainAddServices) {
                                difference = this.manSsum;
                                for (var index in this.account.CalcData.Products) {
                                    var prod = this.account.CalcData.Products[index];
                                    if (!(prod.IsFine || prod.Item.toString().substr(0, 1) == '8')) {
                                        var se = prod.SaldoBegin
                                            // + prod.Recalculation
                                            - prod.Paid;
                                        if (prod.AccrualsCheck) {
                                            se = se + prod.Accruals;
                                        }
                                        //difference -= this.Debt(prod.SaldoEnd);
                                        difference -= this.Debt(se);
                                    }
                                }
                                if (difference > 0.0) {
                                    for (var index in this.account.CalcData.Products) {
                                        var prod = this.account.CalcData.Products[index];
                                        if (prod.IsFine || prod.Item.toString().substr(0, 1) == '8') {
                                            var se = prod.SaldoBegin
                                                //+ prod.Recalculation
                                                - prod.Paid;
                                            if (prod.AccrualsCheck) {
                                                se = se + prod.Accruals;
                                            }
                                            /*
                                            var sum = this.Debt(prod.SaldoEnd) / this.sumFineDuty * difference;
                                            if (sum > this.Debt(prod.SaldoEnd))
                                                sum = this.Debt(prod.SaldoEnd);
                                            */
                                            var sum = this.Debt(se) / this.sumFineDuty * difference;
                                            if (sum > this.Debt(se))
                                                sum = this.Debt(se);
                                            prod.ToPayProd = Math.round(sum * 100) / 100;
                                            if (se > 0) {
                                                lastIndex = index;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                for (var index in this.account.CalcData.Products) {
                                    var prod = this.account.CalcData.Products[index];
                                    if (!(prod.IsFine || prod.Item.toString().substr(0, 1) == '8')) {
                                        var se = prod.SaldoBegin
                                            // + prod.Recalculation
                                            - prod.Paid;
                                        if (prod.AccrualsCheck) {
                                            se = se + prod.Accruals;
                                        }
                                        //var sum = this.Debt(prod.SaldoEnd) / this.sumMainAddServices * this.manSsum;
                                        var sum = this.Debt(se) / this.sumMainAddServices * this.manSsum;
                                        prod.ToPayProd = Math.round(sum * 100) / 100;
                                        if (se > 0) {
                                            lastIndex = index;
                                        }
                                    }
                                    else
                                        prod.ToPayProd = 0.0;
                                }
                            }
                        }
                    }
                    else {
                        if (difference < 0.0) {
                            if (this.manSsum >= this.sumMainAddServices) {
                                var diff = this.manSsum;
                                for (var index in this.account.CalcData.Products) {
                                    var prod = this.account.CalcData.Products[index];
                                    if (!(prod.IsFine || prod.Item.toString().substr(0, 1) == '8')) {
                                        var se = prod.SaldoBegin
                                            // + prod.Recalculation
                                            - prod.Paid;
                                        if (prod.AccrualsCheck) {
                                            se = se + prod.Accruals;
                                        }
                                        //diff -= this.Debt(prod.SaldoEnd);
                                        diff -= this.Debt(se);
                                    }
                                }
                                if (diff > 0.0) {
                                    for (var index in this.account.CalcData.Products) {
                                        var prod = this.account.CalcData.Products[index];
                                        if (prod.IsFine || prod.Item.toString().substr(0, 1) == '8') {
                                            var se = prod.SaldoBegin
                                                // + prod.Recalculation
                                                - prod.Paid;
                                            if (prod.AccrualsCheck) {
                                                se = se + prod.Accruals;
                                            }
                                            /*
                                            var sum = this.Debt(prod.SaldoEnd) / this.sumFineDuty * diff;
                                            if (sum > this.Debt(prod.SaldoEnd)) {
                                                sum = this.Debt(prod.SaldoEnd);
                                            }
                                            */
                                            var sum = this.Debt(se) / this.sumFineDuty * diff;
                                            if (sum > this.Debt(se)) {
                                                sum = this.Debt(se);
                                            }
                                            prod.ToPayProd = Math.round(sum * 100) / 100;
                                            if (se > 0) {
                                                lastIndex = index;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                for (var index in this.account.CalcData.Products) {
                                    var prod = this.account.CalcData.Products[index];
                                    if (!(prod.IsFine || prod.Item.toString().substr(0, 1) == '8')) {
                                        var se = prod.SaldoBegin
                                            // + prod.Recalculation
                                            - prod.Paid;
                                        if (prod.AccrualsCheck) {
                                            se = se + prod.Accruals;
                                        }
                                        //var sum = this.Debt(prod.SaldoEnd) / this.sumMainAddServices * this.manSsum;
                                        var sum = this.Debt(se) / this.sumMainAddServices * this.manSsum;
                                        prod.ToPayProd = Math.round(sum * 100) / 100;
                                        lastIndex = index;
                                    }
                                    else
                                        prod.ToPayProd = 0.0;
                                }
                            }
                        }
                        if (difference > 0.0 && this.sumWeightFactors != 0.0)
                            for (var index in this.account.CalcData.Products) {
                                var prod = this.account.CalcData.Products[index];
                                if (!prod.IsFine) {
                                    var se = prod.SaldoBegin
                                        // + prod.Recalculation
                                        - prod.Paid;
                                    if (prod.AccrualsCheck) {
                                        se = se + prod.Accruals;
                                    }
                                    var sum = 0.0;
                                    if (prod.Item == 13)
                                        sum = difference / this.sumWeightFactors * W13;
                                    if (prod.Item == 99)
                                        sum = difference / this.sumWeightFactors * W99;
                                    if (prod.Item == 139)
                                        sum = difference / this.sumWeightFactors * W139;
                                    if (prod.Item == 149)
                                        sum = difference / this.sumWeightFactors * W149;
                                    //prod.ToPayProd = Math.round((sum + this.Debt(prod.SaldoEnd)) * 100) / 100;
                                    prod.ToPayProd = Math.round((sum + this.Debt(se)) * 100) / 100;
                                    if (se > 0) {
                                        lastIndex = index;
                                    }
                                }
                            }
                    }

                    var sumProds = this.account.CalcData.Products.reduce(function (p, c) { return p + c.ToPayProd; }, 0);
                    if (sumProds != this.manSsum) {
                        var delta = sumProds - this.manSsum;
                        if (lastIndex >= 0) {
                            this.account.CalcData.Products[lastIndex].ToPayProd =
                                Math.round(
                                    (this.account.CalcData.Products[lastIndex].ToPayProd - Math.round((Math.round(delta * 1000) / 1000) * 100) / 100)
                                    * 100) / 100;

                        }
                    }

                    this.calcSum();
                }
            },
            Debt: function (saldo) {
                saldo = Number(saldo);
                return (saldo > 0.0) ? saldo : 0.0;
            },

            calcSum: function () {
                var sum = 0.0;
                if (this.account.CalcData.CanPay) {
                    for (var p in this.account.CalcData.Products) {
                        if (this.account.CalcData.Products[p].ToPayCheck) {
                            if (Number(this.account.CalcData.Products[p].ToPayProd) > 0) {
                                sum += Number(this.account.CalcData.Products[p].ToPayProd);
                            }
                        }
                    }
                }
                else {
                    for (var p in this.account.CalcData.Products) {
                        sum += this.account.CalcData.Products[p].SaldoEnd;
                    }
                }
                this.ssum = Math.round(sum * 100) / 100;
            },
            SavePay: function (index) {
                this.savePay = this.account.CalcData.Products[index].ToPayProd;
            },
        },
        watch: {
            ssum: function (newSum) {
                this.$emit('updateSum');
            }
        },
        mounted() {
            this.calcSum();
            this.sumAllServices = 0.0;  // Общая сумма начислений по счёту.
            this.sumMainAddServices = 0.0; // Сумма начислений по ОУ и ДУ.
            this.sumFineDuty = 0.0;     // Пеня и госпошлина.
            this.sumWeightFactors = 0.0; // Сумма весовых коэффициентов.
            let rowsum = 0.0; // сумма по строке
            for (var index in this.account.CalcData.Products) {
                rowsum = this.Debt(this.account.CalcData.Products[index].SaldoEnd);
                this.sumAllServices += rowsum;
                if (this.account.CalcData.Products[index].IsFine || this.account.CalcData.Products[index].Item.toString().substr(0, 1) == '8')
                    this.sumFineDuty += this.Debt(this.account.CalcData.Products[index].SaldoEnd);
                else
                    this.sumMainAddServices += this.Debt(this.account.CalcData.Products[index].SaldoEnd);
                if (this.account.CalcData.Products[index].Item == 13)
                    this.sumWeightFactors += W13;
                if (this.account.CalcData.Products[index].Item == 99)
                    this.sumWeightFactors += W99;
                if (this.account.CalcData.Products[index].Item == 139)
                    this.sumWeightFactors += W139;
                if (this.account.CalcData.Products[index].Item == 149)
                    this.sumWeightFactors += W149;



                if (this.account.CalcData.Products[index].SaldoEnd > 0.0) {
                    this.account.CalcData.Products[index].ToPayCheck = true;
                    //this.account.CalcData.Products[index].AccrualsCheck = true;
                    this.account.CalcData.Products[index].IsUserPay = false;
                    this.account.CalcData.Products[index].ToPayProd = this.account.CalcData.Products[index].SaldoEnd;
                }
                else
                    this.account.CalcData.Products[index].ToPayProd = 0.0;

            }
            this.calcSum();
            this.manSsum = this.ssum;
        }
    }
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/components/account-recalc.vue